import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { CRTestRef, HVTestRef, PDTestRef, valuesListModel, ValuesStore } from "@src/views/test-values/domain/values.model";



export const fetchVoltageGrade =
    createAsyncThunk<any[], void>("voltageGrades/fetchVoltageGrades",
        async () => {
            const url = `${AppConstants.api}/voltage-grades`
            const response = await api.get<any[]>(url)
            return response.data
        }
    );
export const fetchCableSize =
    createAsyncThunk<any[], void>("cableSize/fetchCableSizes",
        async () => {
            const url = `${AppConstants.api}/cable-sizes`
            const response = await api.get<any[]>(url)
            return response.data
        }
    );
export const fetchConductorType =
    createAsyncThunk<any[], void>("conductorType/fetchConductorTypes",
        async () => {
            const url = `${AppConstants.api}/conductor-types`
            const response = await api.get<any[]>(url)
            return response.data
        }
    );

export const fetchCRValues =
    createAsyncThunk<any[], void>("crvalues/fetchCRValues",
        async () => {
            const url = `${AppConstants.api}/test/input/crTests`
            const response = await api.get<any[]>(url)
            return response.data
        }
    );
export const fetchHVValues =
    createAsyncThunk<any[], void>("hvvalues/fetchHVValues",
        async () => {
            const url = `${AppConstants.api}/test/input/hvTests`
            const response = await api.get<any[]>(url)
            return response.data
        }
    );

export const fetchPDValues =
    createAsyncThunk<any[], void>("pdvalues/fetchPDValues",
        async () => {
            const url = `${AppConstants.api}/test/input/pdTests`
            const response = await api.get<any[]>(url)
            return response.data
        }
    );


export const createCRValue = createAsyncThunk(
    "crValues/createCRValue",
    async (crValueData: CRTestRef, { rejectWithValue }) => {
        try {
            console.log("**********",crValueData)
            if (!crValueData?.id) {
                const response = await api.post<ApplicationResponse<CRTestRef>>(
                    `${AppConstants.api}/test/input/crTests`,
                    {
                        crInputValue: crValueData.crInputValue,
                        conductorType: crValueData.conductorType,
                        cableSize: crValueData.cableSize,
                    }
                );
                return response.data.data;
            }
            const response = await api.patch<ApplicationResponse<CRTestRef>>(
                `${AppConstants.api}/test/input/crTests/${crValueData.id}`,
                {
                    crInputValue: crValueData.crInputValue,
                }
            );
            return response.data.data;
        } catch (err) {
            console.error(" Error:", err);
            return rejectWithValue("Failed to create CR Value");
        }
    }
);


export const createPDValue = createAsyncThunk(
    "pdValues/createPDValue",
    async (pdValueData: PDTestRef, { rejectWithValue }) => {
        try {
            if (!pdValueData?.id) {
                const response = await api.post<ApplicationResponse<PDTestRef>>(
                    `${AppConstants.api}/test/input/pdTests`,
                    pdValueData
                );
                return response.data.data;
            }
            const response = await api.patch<ApplicationResponse<PDTestRef>>(
                `${AppConstants.api}/test/input/pdTests/${pdValueData.id}`,
                {
                    "kvValue": pdValueData.kvValue
                }
            );
            return response.data.data
        } catch (err) {
            console.error("Error: ", err);
            return rejectWithValue("Failed to create PD Value");
        }
    }
);

export const createHVValue = createAsyncThunk(
    "hvValues/createHVValue",
    async (hvValueData: HVTestRef, { rejectWithValue }) => {
        try {
            if (!hvValueData?.id){

            const response = await api.post<ApplicationResponse<HVTestRef>>(
                `${AppConstants.api}/test/input/hvTests`,
                hvValueData
            );
            return response.data.data;
            }
            const response = await api.patch<ApplicationResponse<HVTestRef>>(`${AppConstants.api}/test/input/hvTests/${hvValueData.id}`, {
                kvValue: hvValueData.kvValue,
                voltageGrade: hvValueData.voltageGrade
            })
            return response.data.data;
        } catch (err) {
            console.error(" Error:", err);
            return rejectWithValue("Failed to create HV Value");
        }
    }
);



export const deleteValues = createAsyncThunk(
    "values/deleteValues",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApplicationResponse<any[]>>(
                `${AppConstants.api}/test/input/testInputs/${id}`
            );
            console.log("Response", response)
            return response.data.data || [];
        } catch (err) {
            console.error("Delete Value Error:", err);
            return rejectWithValue("Failed to delete Value");
        }
    }
);
const initialState: ValuesStore = {
    crMinimal: { status: "idle", error: null, data: [] },
    hvMinimal: { status: "idle", error: null, data: [] },
    pdMinimal: { status: "idle", error: null, data: [] },
    cableSizeMinimal: { status: "idle", error: null, data: [] },
    voltageGradeMinimal: { status: "idle", error: null, data: [] },
    conductorTypeMinimal: { status: "idle", error: null, data: [] }


};

const valueSlices = createSlice({
    name: "values",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCRValues.pending, (state) => {
                state.crMinimal.status = "loading";
                state.crMinimal.data = [];
                state.crMinimal.error = null;
            })
            .addCase(fetchCRValues.fulfilled, (state, action) => {
                state.crMinimal.status = "idle";
                state.crMinimal.data = action.payload ?? [];
                state.crMinimal.error = null;
            })
            .addCase(fetchCRValues.rejected, (state, action) => {
                state.crMinimal.status = "failed";
                state.crMinimal.data = [];
                state.crMinimal.error = action.payload as string;
            })
            .addCase(fetchPDValues.pending, (state) => {
                state.pdMinimal.status = "loading";
                state.pdMinimal.data = [];
                state.pdMinimal.error = null;

            })
            .addCase(fetchPDValues.fulfilled, (state, action) => {
                state.pdMinimal.status = "idle";
                state.pdMinimal.data = action.payload ?? [];
                state.pdMinimal.error = null;
            })
            .addCase(fetchPDValues.rejected, (state, action) => {
                state.pdMinimal.status = "failed";
                state.pdMinimal.data = [];
                state.pdMinimal.error = action.payload as string;
            })
            .addCase(fetchHVValues.pending, (state) => {
                state.hvMinimal.status = "loading";
                state.hvMinimal.data = [];
                state.hvMinimal.error = null;
            })
            .addCase(fetchHVValues.fulfilled, (state, action) => {
                state.hvMinimal.status = "idle";
                state.hvMinimal.data = action.payload ?? [];
                state.hvMinimal.error = null;
            })
            .addCase(fetchHVValues.rejected, (state, action) => {
                state.hvMinimal.status = "failed";
                state.hvMinimal.data = [];
                state.hvMinimal.error = action.payload as string;
            })


            .addCase(fetchCableSize.pending, (state) => {
                state.cableSizeMinimal.status = "loading";
                state.cableSizeMinimal.data = [];
                state.cableSizeMinimal.error = null;

            })
            .addCase(fetchCableSize.fulfilled, (state, action) => {
                state.cableSizeMinimal.status = "idle";
                state.cableSizeMinimal.data = action.payload ?? [];
                state.cableSizeMinimal.error = null;
            })
            .addCase(fetchCableSize.rejected, (state, action) => {
                state.cableSizeMinimal.status = "failed";
                state.cableSizeMinimal.data = [];
                state.cableSizeMinimal.error = action.payload as string;

            })
            .addCase(fetchConductorType.fulfilled, (state, action) => {
                state.conductorTypeMinimal.status = "idle";
                state.conductorTypeMinimal.data = action.payload ?? [];
                state.conductorTypeMinimal.error = null;
            }
            )
            .addCase(fetchConductorType.rejected, (state, action) => {
                state.conductorTypeMinimal.status = "failed";
                state.conductorTypeMinimal.data = [];
                state.conductorTypeMinimal.error = action.payload as string;
            }
            )
            .addCase(fetchConductorType.pending, (state) => {
                state.conductorTypeMinimal.status = "loading";
                state.conductorTypeMinimal.data = [];
                state.conductorTypeMinimal.error = null;
            }
            )
            .addCase(fetchVoltageGrade.fulfilled, (state, action) => {
                state.voltageGradeMinimal.status = "idle";
                state.voltageGradeMinimal.data = action.payload ?? [];
                state.voltageGradeMinimal.error = null;
            }
            )
            .addCase(fetchVoltageGrade.rejected, (state, action) => {
                state.voltageGradeMinimal.status = "failed";
                state.voltageGradeMinimal.data = [];
                state.voltageGradeMinimal.error = action.payload as string;
            }
            )
            .addCase(fetchVoltageGrade.pending, (state) => {
                state.voltageGradeMinimal.status = "loading";
                state.voltageGradeMinimal.data = [];
                state.voltageGradeMinimal.error = null;
            })



    },
});
export default valueSlices.reducer;